export default {
    cRegisterType(state, val) {
        state.registerType = val;
    },
    registerStep(state, val) {
        console.log(state, val, '内存')
        state.registerStep = state.registerStep + val;
    },
    resetRegisterStep(state, val = 0) {
        state.registerStep = val;
    },
    findPsStep(state, val = 1) {
        state.findPsStep = state.findPsStep + val;
    },
    currentPage(state, val = '首页') {
        state.currentPage = val;
    },
    currentNewsId(state, val = 'id1') {
        state.joinSucIs = val;
    },
    joinSucIs(state, val = 'false') {
        state.joinSucIs = val;
    },
    currentNewsDetail(state, val = {}) {
        state.currentNewsDetail = val;
    },
    isNoLogin(state, val = 'false') {
        state.isNoLogin = val;
    },
    isPopTip(state, val = false) {
        state.isPopTip = val;
    }
}